/**
 * @file The Projects summary total: `projectsByStage`'s `totalValue`, the
 * summed value of every active project before the list cap, at the Projects
 * level and period. Consumer: `useAnalyticsProjectsSearch`. It is served, so
 * it matches every active project even when the list stops at its cap, and
 * pipeline rows, which never add up across form types, are never summed. The
 * caller labels it a projection. A refused value column or an unanswered
 * answer passes through as an unanswered figure and never reads as zero.
 */
import { analyticsMalformedAnswer } from './analyticsMalformedAnswer';
import type { AnalyticsProjects } from './analyticsProjectsTab.types';
import type { AnalyticsDecimalFigure } from './index.types';

export const analyticsProjectsTotal = (
  projects: AnalyticsProjects,
): AnalyticsDecimalFigure => {
  if (projects.status !== 'answered') return projects;
  const { totalValue, refusedValue } = projects;
  if (refusedValue !== null)
    return { status: 'refusedColumn', column: refusedValue };
  if (totalValue === null) return analyticsMalformedAnswer('projectsByStage');
  return { status: 'answered', decimal: totalValue };
};
